module.exports = __webpack_public_path__ + "img/2022-16.e9fe0c05.jpg";